module.exports = __webpack_public_path__ + "img/11.4ce178ad.png";